<style scoped lang="scss">
form {
    h2 {
        color: #000;
    }
    ::v-deep(.formkit-select-icon) {
        height: 50px;
        margin: 0;
        padding: 0;
    }
}
main .container .card {
    background-color: rgba(91, 91, 98, 0.08);
}
</style>

<template>
    <div>
    <div class="mb-5">
        <h1 class="page-title">{{ title }} {{ type }}</h1>
    </div>
    <div class="max-w-screen-xl mx-auto">
        <div class="flex flex-wrap -mx-4">
        <div class="w-full lg:w-1/4 px-3">
            <div class="mb-5">
            <div class="card w-75 shadow-xl">
                <div class="card-body items-center text-center">
                    <h5 class="card-title">Image Web</h5>
                    <div v-if="type && type !== 'login'" class="text-xs">Format requis : 2560 x 696 px</div>
                    <div v-if="type && type === 'login'" class="text-xs">Format requis : 1350 x 1920 px</div>
                    <UploadImage :image-preview-url="form.imageWeb ? form.imageWeb.url : getBaseUrl() + '/media/blank2.png'"
                        @image-removed="onImageWebRemoved"
                        @imageUploaded="onImageWebUpload"
                        @error="onImageUploadError"
                    />
                </div>
            </div>
            </div>
            <div class="mb-5" v-if="type !== 'login'">
            <div class="card w-75 shadow-xl">
                <div class="card-body items-center text-center">
                    <h5 class="card-title">Image Mobile</h5>
                    <UploadImage :image-preview-url="form.imageMobile ? form.imageMobile.url : getBaseUrl() + '/media/blank2.png'"
                        @image-removed="onImageMobileRemoved"
                        @imageUploaded="onImageMobileUpload"
                        @error="onImageUploadError"
                    />
                </div>
            </div>
            </div>
        </div>

        <div class="w-full lg:w-3/4 px-4">
        <div class="card w-full shadow-xl">
        <div class="card-body">
            <div class="w-full">


            <FormKit type="form"
                :actions="false"
                :model="form"
                @submit="onSubmit"
                #default="{ state: { valid } }"
                outer-class="w-full"
                incomplete-message="Veuillez remplir tous les champs correctement"
            >
            <div :class="{ hidden: type === 'login' }">
            <FormKit 
                type="select" 
                label="Type *" 
                name="itemType" 
                v-model="form.itemType" 
                :options="itemTypeOptions" 
                validation="required" 
                :validation-messages="{
                required: 'Ce champ est obligatoire.'
            }" />
                <label class="formkit-label" 
                    v-if="form.itemType === '1' || 
                        form.itemType === '2' || 
                        form.itemType === '5'">
                    Uuid
                </label>
                <label class="formkit-label" v-if="form.itemType === '4'">Lien de redirection</label>
                <label class="formkit-label" v-show="form.itemType === '4'">Si lien de redirection type voyage, veuillez vous assurer de mettre un de ces formats: </label>
                <label class="formkit-label" v-show="form.itemType === '4'">https://app.club-employes.com/voyage?id=2209{ce_token} : pour être redirigé vers un produit spécifique où 2209 représente l'id de l'offre voyage</label>
                <label class="formkit-label" v-show="form.itemType === '4'">https://app.club-employes.com/voyage{ce_token} : pour être redirigé vers la page d'accueil de voyage</label>
                
                <label class="formkit-label" v-if="form.itemType === '3'">Mot(s) recherché(s)</label>
                
                
                <FormKit type="text" name="itemValue"   :value="form.itemValue"  v-model="form.itemValue" />

                
                </div>
                <FormKit type="number"
                    name="position"
                    label="Position *"
                    v-model="form.position"
                    validation="required|min:1"
                    :validation-messages="{
                        required: 'Ce champ est obligatoire.',
                        min: 'Ce champ doit être un nombre décimal superieur à 0',
                }"
                />
                <FormKit v-if="type == 'login'"
                    type="select"
                    label="Plateforme *"
                    name="platform"
                    v-model="form.domaine"
                    :options="[
                            { label: 'Selectionnez la plateforme', value: null },
                            { label: 'Club Employés', value: 'ce' },
                            { label: 'Gifteo', value: 'gifteo' }
                        ]"
                    validation="required"
                    :validation-messages="{
                            required: 'Ce champ est obligatoire.'
                        }"
                />
                <div class="card-actions">
                    <div v-if="loading === false">
                        <FormKit type="submit"
                            :label="submitBtnLabel"
                            :disabled="!valid"
                            :class="{ 'btn-primary': true, 'btn-block': true }"
                        />
                    </div>
                    <FormKit type="button"
                        label="Annuler"
                        @click="onCancel"
                        :class="{ 'btn-secondary': true, 'btn-block': true }"
                    />
                    </div>
                </FormKit>
            </div>
        </div>
        </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script lang="ts" setup>
import {computed, onBeforeMount, ref} from 'vue';
import { useRoute } from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {fetchCarouselByUuid} from "@/_services/homepage/carousel";
import {ICarousel} from "@/models/homepage/ICarousel";
import { getItemTypeOptions } from '@/_services/homepage/itemTypeServices.ts'; 

const title = ref<string>("Edition de Carrousel");
const submitBtnLabel = 'Editer';
const carousel = ref<ICarousel>({} as ICarousel);
const route = useRoute();
const uuidRouteParam = ref<string>("");
const router = useRouter();
const loading = ref<boolean>(true);
const filledFieldCount = ref<number>(0);
const itemTypeOptions = getItemTypeOptions();
const type = computed(() => route.meta?.type as string | undefined)

onBeforeMount(async () => {
    loading.value = true;
    uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
    if (uuidRouteParam.value.length) {
        carousel.value = await fetchCarouselByUuid(uuidRouteParam.value);
        await hydrateForm(carousel.value);
        loading.value = false;
    }
});

const form = ref<ICarousel>({
    position: null,
    imageWeb: null,
    imageMobile: null,
    itemType: null,
    itemValue: null,
    pageType: type.value == 'login' ? 'login' : 'homepage',
    domaine: null,
});

const hydrateForm = (carousel: ICarousel) => {
    form.value = {
        position: carousel.position,
        imageWeb: carousel.imageWeb,
        imageMobile: carousel.imageMobile,
        itemValue: carousel.itemValue,
        itemType: carousel.itemType,
        pageType: carousel.pageType,
        domaine: carousel.domaine,
    }
}

const onSubmit = async (formData) => {
    try {
        if (type.value == 'login') {
            if (null == form.value.imageWeb) {
                swal.warning("L'image web est obligatoire.");
                return false;
            }
        } else {
            if (null == form.value.imageWeb || null == form.value.imageMobile) {
                swal.warning('Les deux images sont obligatoires.');
                return false;
            }
        }
        
        filledFieldCount.value = 0;

        const payload = {
            position: parseInt(formData.position),
            imageWeb: null !== form.value.imageWeb ? `${form.value.imageWeb.uuid}` : null,
            imageMobile: null !== form.value.imageMobile ? `${form.value.imageMobile.uuid}` : `${form.value.imageWeb.uuid}`,
            itemValue: formData.itemValue,
            itemType: parseInt(formData.itemType),
            pageType: form.value.pageType,
            domaine: formData.platform ?? 'ce',
        }
        swal.confirm(`Êtes-vous sûr de vouloir éditer un carrousel ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && update(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const update = (data) => {
    if(uuidRouteParam.value.length) {
        ApiService.patch('carousels', uuidRouteParam.value, data)
            .then(() => {
                loading.value = false;
                swal.info("Edition avec succès")
                    .then((result) => {
                        if (result.isConfirmed) {
                            router.go(-1);
                        }
                    });
            })
            .catch((axiosError) => {
                swal.error("Une erreur est survenue lors de la modification");
                axiosError.response.data.errors.forEach((error) => {
                    if (error.message.startsWith("Item not found for")
                        || error.message.startsWith("Could not convert database value")) {
                        swal.error("Une erreur est survenue au moment de la modification, l’uuid ajoutée n’existe pas.");
                    }
                });
            });
    }
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'édition ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            if (type.value && type.value == 'login') {
                router.push({
                    name: "carouselLoginList"
                });
            } else {
                router.push({
                    name: "carouselList"
                });
            }
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}
</script>